import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, Subject, combineLatest, merge } from 'rxjs';
import { map, mergeMap, scan, switchMap, tap } from 'rxjs/operators';
import { Manufacturers, Users } from '../_types/users';
import { User } from '@app/core/user/user.types';

@Injectable({
  providedIn: 'root'
})
export class AdminViewsService {
  private _manufacturers: BehaviorSubject<Manufacturers[] | null> = new BehaviorSubject(null);
  private _myManufacturers: BehaviorSubject<Manufacturers[] | null> = new BehaviorSubject(null);

  plentyApi = environment.plentyApi;

  users$ = this._httpClient.get<Users[]>(this.plentyApi + '/api/users',
  ).pipe(
    map((data: any): Users[] => {
      return data;
    }),
  );

  //create User
  private createUserSubject = new Subject<any>()
  private createUserSubjectAction$ = this.createUserSubject.asObservable();


  createUser(user: { firstName: string; lastName: string; email: string; userName: string, password: string, isAdmin: boolean }) {
    this.createUserSubject.next(user);
  }

  private createUser$ = this.createUserSubjectAction$.pipe(
    switchMap(user => this._httpClient.post(`${this.plentyApi}/api/account/register`, user).pipe(
      map((registredUser: any) => {
        console.log('createUser', registredUser.userId);
        return { userId: registredUser.userId, firstName: user.firstName, lastName: user.lastName, username: user.userName, email: user.email } as Users;
      })
    ))
  )




  //delete User
  private deleteUserSubject = new Subject<string>();
  private deleteUserAction$ = this.deleteUserSubject.asObservable();

  deleteUser(userId: string) {
    console.log(userId);
    this.deleteUserSubject.next(userId);
  }

  deleteUser$ = this.deleteUserAction$.pipe(
    switchMap((userId: string) => {
      return this._httpClient.delete(`${this.plentyApi}/api/Account/${userId}`).pipe(
        map(_ => userId)
      );
    }),
    tap(data => console.log(data))
  )


  userModification$ = merge(this.users$, this.createUser$, this.deleteUser$).pipe(
    scan((acc, value) => (value instanceof Array) ? [...value] : this.modifyUser(acc as Users[], value), [] as Users[]),
    tap(data => console.log('userWithAddOption', data))
  )

  modifyUser(users: Users[], userData: any): Users[] {
    if (typeof (userData) == "string") {
      //delete user
      const index = users.findIndex(user => user.userId === (userData as string));
      users.splice(index, 1);
      return [...users];
    }
    else {
      return [...users, userData as Users]
    }

  }

  get manufacturers$(): Observable<Manufacturers[]> {
    return this._manufacturers.asObservable();
  }

  get myManufacturers$(): Observable<Manufacturers[]> {
    return this._myManufacturers.asObservable();
  }

  constructor(private _httpClient: HttpClient) { }


  getManufacturers(): Observable<Manufacturers[]> {
    return this._httpClient.get<Manufacturers[]>(this.plentyApi + '/api/Manufacturers',
    ).pipe(
      map((data: any): Manufacturers[] => {
        this._manufacturers.next(data);
        return data;
      }),
    );
  }

  getUserManufacturers(id: string): Observable<Manufacturers[]> {
    return this._httpClient.get<Manufacturers[]>(this.plentyApi + '/api/users/' + id + '/Manufacturers',
    ).pipe(
      map((data: any): Manufacturers[] => {
        this._myManufacturers.next(data);
        return data;
      }),
    );
  }


  updateManufacturers(userId: string, manufacturerIds: number[]) {
    return this._httpClient.put<Manufacturers[]>(this.plentyApi + '/api/Manufacturers/UpdateUserManufacturers', { userId, manufacturerIds }
    ).pipe(
      map((data: any): any => {
        console.log(data);
        return data;
      }),
    );
  }



}
